import axios from "axios.js";
import { showSnackbar } from "./UiAction";

// Defines all states values
export const GET_TOTALSCHOOL_REPORT_LIST = "GET_TOTALSCHOOL_REPORT_LIST";
export const GET_PRIMARYSCHOOL_REPORT_LIST = "GET_PRIMARYSCHOOL_REPORT_LIST";
export const GET_SECONDARYSCHOOL_REPORT_LIST = "GET_SECONDARYSCHOOL_REPORT_LIST";
export const GET_SCHOOLWITHDRIVER_REPORT_LIST = "GET_SCHOOLWITHDRIVER_REPORT_LIST";
export const GET_OVERSPEED_REPORT_LIST = "GET_OVERSPEED_REPORT_LIST";
export const GET_SOS_REPORT_LIST = "GET_SOS_REPORT_LIST";
export const GET_DAILYATTENDANCE_REPORT_LIST = "GET_DAILYATTENDANCE_REPORT_LIST";
export const GET_ROLEWISE_ATTENDANCE_REPORT_LIST = "GET_ROLEWISE_ATTENDANCE_REPORT_LIST";
export const GET_VEHICLE_REPORT_LIST = "GET_VEHICLE_REPORT_LIST";
export const GET_CLASS_REPORT_LIST = "GET_CLASS_REPORT_LIST";
export const GET_CASTE_REPORT_LIST = "GET_CASTE_REPORT_LIST";
export const GET_NOTIFICATION_REPORT_LIST = "GET_NOTIFICATION_REPORT_LIST";
export const GET_BENEFICIARY_REPORT_LIST = "GET_BENEFICIARY_REPORT_LIST";
export const GET_DAILYATTENDANCESCHOOL_REPORT_LIST = "GET_DAILYATTENDANCESCHOOL_REPORT_LIST";
export const RESET_REPORT_DATA = 'RESET_REPORT_DATA';
export const GET_DAILY_REPORT_LIST = 'GET_DAILY_REPORT_LIST';
export const GET_STUDENT_DAILY_ATTENDANCE_REPORT_LIST = 'GET_STUDENT_DAILY_ATTENDANCE_REPORT_LIST';
export const SET_LOADER = "SET_LOADER";

export const setLoader = (isLoading) => ({
  type: SET_LOADER,
  payload: isLoading,
});

export const getTotalSchoolReportList = (page, rowsPerPage, year, totalSearch) => (dispatch) => { // get total school report api
  dispatch(setLoader(true)); // Show loader
  axios.post(`/report/school?page=${page}&size=${rowsPerPage}`, totalSearch, {
    headers: {
      'academic_year': year,
    },
  }).then((res) => {
    dispatch({
      type: GET_TOTALSCHOOL_REPORT_LIST,
      payload: res.data.data,
    });
  })
    .catch((error) => {
      dispatch(showSnackbar("Total School Report not available", 'top', "info"));
      dispatch(setLoader(false)); // Hide loader in case of error
    });
};

export const getPrimarySchoolReportList = (page, rowsPerPage, year, primarySearch) => (dispatch) => { // get primary school counts reports api
  dispatch(setLoader(true)); // Show loader
  axios
    .post(`/report/school/primary?page=${page}&size=${rowsPerPage}`, primarySearch, {
      headers: {
        academic_year: year,
      },
    })
    .then((res) => {
      dispatch({
        type: GET_PRIMARYSCHOOL_REPORT_LIST,
        payload: res.data.data,
      });
    })
    .catch((error) => {
      dispatch(showSnackbar("Primary School Report not available", 'top', "info"));
      dispatch(setLoader(false)); // Hide loader in case of error
    });
};

export const getSecondarySchoolReportList = (page, rowsPerPage, year, secondarySearch) => (dispatch) => { // get secondary school counts api
  dispatch(setLoader(true)); // Show loader
  axios
    .post(`/report/school/secondary?page=${page}&size=${rowsPerPage}`, secondarySearch, {
      headers: {
        academic_year: year,
      },
    })
    .then((res) => {
      dispatch({
        type: GET_SECONDARYSCHOOL_REPORT_LIST,
        payload: res.data.data,
      });
    })
    .catch((error) => {
      dispatch(showSnackbar("Secondary Schools Report not available", 'top', "info"));
      dispatch(setLoader(false)); // Hide loader in case of error
    });
};

export const getSchoolWithDriverReportList = (page, rowsPerPage, year, schoolWithDriversSearch) => (dispatch) => {// get school with driver report api
  dispatch(setLoader(true)); // Show loader
  axios
    .post(`/report/driver/register?page=${page}&size=${rowsPerPage}`, schoolWithDriversSearch, {
      headers: {
        academic_year: year,
      },
    })
    .then((res) => {
      dispatch({
        type: GET_SCHOOLWITHDRIVER_REPORT_LIST,
        payload: res.data.data,
      });
    })
    .catch((error) => {
      dispatch(showSnackbar("School With Driver Report not available", 'top', "info"));
      dispatch(setLoader(false)); // Hide loader in case of error
    });
};

export const getOverspeedReportList = (page, rowsPerPage, data, year, type, id) => (dispatch) => {// get overspeed report api 
  dispatch(setLoader(true)); // Show loader
  axios
    .post(`/report/overspeed?page=${page}&size=${rowsPerPage}`, data, {
      headers: {
        academic_year: year,
        filter_type: type,
        filter_code: id,
      }
    })
    .then((response) => {
      dispatch({
        type: GET_OVERSPEED_REPORT_LIST,
        payload: response.data.data,
      });
    })
    .catch((error) => {
      dispatch(showSnackbar("Overspeed Report not available", 'top', "info"));
      dispatch(setLoader(false)); // Hide loader in case of error
    });
};

export const getSOSReportList = (page, rowsPerPage, year, data) => (dispatch) => { // get sos report api
  dispatch(setLoader(true)); // Show loader
  axios
    .post(`/report/sos?page=${page}&size=${rowsPerPage}`, data, {
      headers: {
        academic_year: year,
      }
    })
    .then((response) => {
      dispatch({
        type: GET_SOS_REPORT_LIST,
        payload: response.data.data,
      });
    })
    .catch((error) => {
      dispatch(showSnackbar("SOS Report not available", 'top', "info"));
      dispatch(setLoader(false)); // Hide loader in case of error
    });
};

export const getDailyAttendanceList = (year, data, type, id) => (dispatch) => { // get daily attendance report list
  dispatch(setLoader(true)); // Show loader
  axios
    .post(`/report/attendance/daily`, data, {
      headers: {
        academic_year: year,
        filter_type: type,
        filter_code: id,
      }
    })
    .then((response) => {
      dispatch({
        type: GET_DAILYATTENDANCE_REPORT_LIST,
        payload: response.data.data,
      });
    })
    .catch((error) => {
      dispatch(showSnackbar("Driver Attendance Report not available", 'top', "info"));
      dispatch(setLoader(false)); // Hide loader in case of error
    });
};

export const getRoleWiseAttendanceList = (page, rowsPerPage, year, data, type, id) => (dispatch) => { // get role wise attendance list
  dispatch(setLoader(true)); // Show loader
  axios
    .post(`/report/attendance/role?page=${page}&size=${rowsPerPage}`, data, {
      headers: {
        filter_type: type,
        filter_code: id,
        academic_year: year,
      }
    })
    .then((response) => {
      dispatch({
        type: GET_ROLEWISE_ATTENDANCE_REPORT_LIST,
        payload: response.data.data,
      })
    })
    .catch((error) => {
      dispatch(showSnackbar("Monthly Attendance Report not available", 'top', "info"));
      dispatch(setLoader(false)); // Hide loader in case of error
    });
};

export const getVehicleReportList = (year, type, id, vehicleSearch) => (dispatch) => { // get vehicle report list api
  dispatch(setLoader(true)); // Show loader
  axios.get(`/report/vehicle`, {
    headers: {
      filter_type: type,
      filter_code: id,
      academic_year: year
    },
    vehicleSearch,
  }).then((res) => {
    dispatch({
      type: GET_VEHICLE_REPORT_LIST,
      payload: res.data.data,
    });
  })
    .catch((error) => {
      dispatch(showSnackbar("Vehicle Report not available", 'top', "info"));
      dispatch(setLoader(false)); // Hide loader in case of error
    });
};

export const getClassReportList = (page, rowsPerPage, year, type, id, classSearch) => (dispatch) => { // get class wise report list
  dispatch(setLoader(true)); // Show loader
  axios.post(`/report/class?page=${page}&size=${rowsPerPage}`, classSearch, {
    headers: {
      filter_type: type,
      filter_code: id,
      academic_year: year,
    },
  }).then((res) => {
    dispatch({
      type: GET_CLASS_REPORT_LIST,
      payload: res.data.data,
    });
  })
    .catch((error) => {
      dispatch(showSnackbar("Class Report not available", 'top', "info"));
      dispatch(setLoader(false)); // Hide loader in case of error
    });
};
export const getCasteReportList = (page, rowsPerPage, year, type, id, castSearch) => (dispatch) => { // get caste wise report list
  dispatch(setLoader(true)); // Show loader
  axios.post(`/report/caste?page=${page}&size=${rowsPerPage}`, castSearch, {
    headers: {
      filter_type: type,
      filter_code: id,
      academic_year: year,
    },
  }).then((res) => {
    dispatch({
      type: GET_CASTE_REPORT_LIST,
      payload: res.data.data,
    });
  })
    .catch((error) => {
      dispatch(showSnackbar("Caste Report not available", 'top', "info"));
      dispatch(setLoader(false)); // Hide loader in case of error
    });
};

export const getNotificationReportList = (id, year) => (dispatch) => {// get notification report api
  dispatch(setLoader(true)); // Show loader
  axios.post(`report/schoolcode/${id}/notification`, {}, {
    headers: {
      academic_year: year,
    },
  }).then((res) => {
    dispatch({
      type: GET_NOTIFICATION_REPORT_LIST,
      payload: res.data.data,
    });
  })
    .catch((error) => {
      dispatch(showSnackbar("Notification Report not available", 'top', "info"));
      dispatch(setLoader(false)); // Hide loader in case of error
    });
};

export const getbeneficiaryReportList = (page, rowsPerPage, year, data) => (dispatch) => { // get beneficiary api call
  dispatch(setLoader(true)); // Show loader
  axios.post(`/report/beneficiary?page=${page}&size=${rowsPerPage}`, data, {
    headers: {
      academic_year: year,
    }
  }).then((res) => {
    dispatch({
      type: GET_BENEFICIARY_REPORT_LIST,
      payload: res.data.data,
    });
  })
    .catch((error) => {
      dispatch(showSnackbar("Beneficiary Report not available", 'top', "info"));
      dispatch(setLoader(false)); // Hide loader in case of error
    });
};

export const getDailyReportList = (date, type, id) => (dispatch) => { // get beneficiary api call
  dispatch(setLoader(true)); // Show loader
  axios.get(`/report/daily_report?date=${date}`, {
    headers: {
      filter_type: type,
      filter_code: id,
    }
  }).then((res) => {
    dispatch({
      type: GET_DAILY_REPORT_LIST,
      payload: res.data.data,
    });
  })
    .catch((error) => {
      dispatch(setLoader(false)); // Hide loader in case of error
    });
}

export const getDailyAttendanceSchoolList = (page, rowsPerPage, year, data) => (dispatch) => { // get daily attendance report list
  dispatch(setLoader(true)); // Show loader
  axios
    .post(`/report/attendance/daily/school?page=${page}&size=${rowsPerPage}`, data, {
      headers: {
        academic_year: year,
      }
    })
    .then((response) => {
      dispatch({
        type: GET_DAILYATTENDANCESCHOOL_REPORT_LIST,
        payload: response.data.data,
      });
    })
    .catch((error) => {
      dispatch(showSnackbar("Student Attendance Report not available", 'top', "info"));
      dispatch(setLoader(true)); // Show loader
    });
};

export const getDailyReportBlockList = (date, type, id) => (dispatch) => { // get beneficiary api call
  dispatch(setLoader(true)); // Show loader
  axios.get(`/report/daily_report/blocks?date=${date}`, {}, {
    headers: {
      filter_type: type,
      filter_code: id,
    }
  }).then((res) => {
    dispatch({
      type: GET_DAILY_REPORT_LIST,
      payload: res.data.data,
    });
  })
    .catch((error) => {
      dispatch(showSnackbar("All Blocks Report not available", 'top', "info"));
      dispatch(setLoader(false)); // Hide loader in case of error
    });
}

export const resetReportDataData = () => ({
  type: RESET_REPORT_DATA,
});

export const getStudentDailyAttendanceReportList = (date, type, id) => (dispatch) => { // get student daily attendance api call
  dispatch(setLoader(true)); // Show loader
  axios.get(`/report/student/daily-attendance?date=${date}`, {
    headers: {
      filter_type: type,
      filter_code: id,
    }
  }).then((res) => {
    dispatch({
      type: GET_STUDENT_DAILY_ATTENDANCE_REPORT_LIST,
      payload: res.data.data,
    });
  })
    .catch((error) => {
      dispatch(setLoader(false)); // Hide loader in case of error
    });
}